// src/reporting/pdf/addKpiCards.js
import { PDF_CONTENT_GAP, ensurePageSpace } from "./pdfLayout";

export function addKpiCards(ctx, kpis = [], startY, options = {}) {
  const { doc, margins, usableWidth } = ctx;

  if (!Array.isArray(kpis) || kpis.length === 0) return startY;

  const columns = options.columns || 3;
  const gap = options.gap ?? 8;

  const cardWidth = (usableWidth - gap * (columns - 1)) / columns;

  // Reduced vertical size
  const cardHeight = 40;

  let y = ensurePageSpace(ctx, startY, cardHeight + 8);

  kpis.forEach((kpi, index) => {
    const col = index % columns;
    const row = Math.floor(index / columns);

    const x = margins.left + col * (cardWidth + gap);
    const yy = y + row * (cardHeight + gap);

    // rounded borders
    doc.setDrawColor(220);
    doc.setLineWidth(0.8);
    doc.setFillColor(248, 248, 248);

    doc.roundedRect(x, yy, cardWidth, cardHeight, 4, 4, "FD");

    // Label
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.setTextColor(90);

    doc.text(String(kpi.label || ""), x + 8, yy + 13, {
      maxWidth: cardWidth - 16,
    });

    // Value
    doc.setFont("helvetica", "bold");

    // Slightly smaller amount text
    doc.setFontSize(10);

    doc.setTextColor(20);

    doc.text(String(kpi.value ?? "—"), x + 8, yy + 28, {
      maxWidth: cardWidth - 16,
    });
  });

  const rowCount = Math.ceil(kpis.length / columns);

  return y + rowCount * cardHeight + (rowCount - 1) * gap + PDF_CONTENT_GAP;
}
